// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"373":"f21856b3","716":"dcfc1633"}[chunkId] + ".chunk.css";
};